import { render, staticRenderFns } from "./CampaignResultTable.vue?vue&type=template&id=ac923738&scoped=true&"
import script from "./CampaignResultTable.vue?vue&type=script&lang=js&"
export * from "./CampaignResultTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignResultTable.vue?vue&type=style&index=0&id=ac923738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac923738",
  null
  
)

export default component.exports